import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Section, SectionContent, SectionItem, SectionTitle } from './atoms';
import { CampaignDetail, UsecaseType } from '@/apis/core';
import { selectSmsUseCases } from '@/shared_elements/selectors';
import { convertTimeWithTimezone } from '@/utils/time';

interface SummarySectionProps {
  campaign: CampaignDetail;
}

const SummarySection: FC<SummarySectionProps> = ({ campaign }) => {
  const useCases = useSelector(selectSmsUseCases);
  const useCaseMapping = useMemo(
    () =>
      useCases.reduce((accumulator, useCase) => {
        accumulator[useCase.id] = useCase;
        return accumulator;
      }, {} as Record<string, UsecaseType>),
    [useCases]
  );

  return (
    <Section>
      <SectionTitle>Summary</SectionTitle>
      <SectionContent>
        <SectionItem title="Brand DBA Name">{campaign.brandName}</SectionItem>
        <SectionItem title="Use Case">
          {useCaseMapping[campaign.usecase]?.displayName ?? campaign.usecase}
        </SectionItem>
        <SectionItem title="Registered On">
          {convertTimeWithTimezone(
            campaign.createDate,
            undefined,
            'MM/DD/YYYY'
          )}
        </SectionItem>
      </SectionContent>
    </Section>
  );
};

export default SummarySection;
